<section>
    <div class="container">
        <div class="row">
            <div class="cctvcouncelling__sec col-md-12 col-sm-12">
                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="pending" (click)="pending()">Pending</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view" (click)="photo()">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="pending">Pending</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Approval list -->

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="Approval">Approved</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- pending list -->

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="pending">Pending</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="pending">Pending</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Approval list -->

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="Approval">Approved</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="Approval">Approved</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="councellist__flex">
                    <div class="campus_address">
                        <ul>
                            <li>
                                <h4 class="building-list">Art & Paintings - Capex</h4>
                                <h4 class="building-list"> 69587458</h4>
                                <h5 class=""> 1st floor, Principal Room, 235</h5>
                            </li>
                        </ul>
                        <ul>
                            <li class="Approval">Approved</li>
                        </ul>
                        <ul>
                            <li>12-08-2024</li>
                            <li>
                                <div class="camera_view">
                                    <img src="../../../../assets/image/bx_bxs-camera.svg" alt="img_missing"
                                        class="camera">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>